import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-insertar-cobranza',
  templateUrl: './insertar-cobranza.component.html',
  styleUrls: ['./insertar-cobranza.component.scss']
})
export class InsertarCobranzaComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;  
  Id_Deposito_Bancario=environment.ID_DEPOSITO_BANCARIO;
  Id_Plantilla_Colocacion=environment.ID_PLANILLA_DE_COLOCACION;
  Id_Plantilla_Remanente=environment.ID_PLANILLA_DE_REMANENTE;

  @Output() cerrarCobranzaDetalle: EventEmitter<boolean>;
  @Output() itemCabeceraDetalle = new EventEmitter();
  @Input() TipoPago: any = [];

  maxDate = moment();
  CobranzaDetalle = {
    Tipo_Pago: '',
    Fecha: "",
    Deposito_Importe: "",
    Deposito_a_Aplicar: "",
    CodigoDeposito: 0,
    idAdquirente: 0,
    idProveedor: 0
  }
  proveedoresArr: any;
  adquirentesArr: any;
  nameField = new FormControl('', [Validators.required]);
  filteredProveedores: Observable<any[]>;
  filteredAdquirentes: Observable<any[]>;

  idProvFilter: any = "";
  idAdqFilter: string = "";
  fecha: string = "";
  flag:boolean;
  form = new FormGroup({
    provFilter: new FormControl(''),
    adqFilter: new FormControl('', [Validators.required]),
    flag: new FormControl(false),
    importe: new FormControl('0', [Validators.required, Validators.maxLength(9)]),
    codigo: new FormControl('0', [Validators.required, Validators.maxLength(9)]),
    fecha: new FormControl('', [Validators.required]),
    tipo: new FormControl('', [Validators.required]),
  });

  constructor(private datepipe: DatePipe) {
    this.cerrarCobranzaDetalle = new EventEmitter();
  }

  ngOnInit() {
    this.obtenerAdquirentesCombo();
    this.obtenerProveedoresCombo();
  }

  tipoPago(event) {
    this.CobranzaDetalle.Tipo_Pago = event;
    this.form.controls["tipo"].setValue(event);
  }

  MetcerrarCabeceraDetalle() {
    this.cerrarCobranzaDetalle.emit();
  }

  EnviarItemCobranzaDetalle(event) {
    if (this.form.valid) {
      this.isChecked();
      this.CobranzaDetalle.Fecha = this.datepipe.transform(this.form.controls["fecha"].value, 'yyyy-MM-dd');
      this.CobranzaDetalle.Deposito_Importe = this.form.controls["importe"].value
      this.CobranzaDetalle.Deposito_a_Aplicar = this.form.controls["importe"].value
      this.CobranzaDetalle.CodigoDeposito = this.form.controls["codigo"].value
      this.CobranzaDetalle.idAdquirente = Number(this.idAdqFilter);
      this.CobranzaDetalle.idProveedor = this.idProvFilter;
      this.itemCabeceraDetalle.emit(this.CobranzaDetalle);      
    } else {
      this.form.markAllAsTouched();
    }
  }
  
  isChecked() {
    if (this.form.controls['flag'].value == false){
      this.form.controls['provFilter'].setValue('');
      this.idProvFilter = "";
    }
  }

  obtenerProvId(provId: string) {
    this.idProvFilter = provId;
  }

  obtenerAdqId(adqId: string) {
    this.idAdqFilter = adqId;
  }

  obtenerRucRazSocialProv(termino: string = '') {
    if (termino != null && termino != '') {
      termino = termino.toLowerCase();
      for (let p of this.proveedoresArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino) >= 0) {
          this.idProvFilter = p.idEmpresa;
          this.form.get('provFilter').setValue(p.Razon_Social);
          break;
        }
      }
    } else {
      this.idProvFilter = '';
      this.form.get('provFilter').setValue('');
    }
  }

  obtenerRucRazSocialAdq(termino: string = '') {
    if (termino != null && termino != '') {
      termino = termino.toLowerCase();
      for (let p of this.adquirentesArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino) >= 0) {
          this.idAdqFilter = p.idEmpresa;
          this.form.get('adqFilter').setValue(p.Razon_Social);
          break;
        }
      }
    } else {
      this.idAdqFilter = '';
      this.form.get('adqFilter').setValue('');
    }
  }

  obtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveedores = this.form.get('provFilter').valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterProv(state) : this.proveedoresArr.slice())
    );
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
        state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }

  obtenerAdquirentesCombo() {
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.form.get('adqFilter').valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterAdq(state) : this.adquirentesArr.slice())
    );
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
        state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }

  FieldValid() {
    return this.form.get('adqFilter').touched && this.form.get('adqFilter').valid;
  }

  FieldInValid() {
    return this.form.get('adqFilter').touched && this.form.get('adqFilter').invalid;
  }

  FieldValid2() {
    return this.form.get('importe').touched && this.form.get('importe').valid;
  }

  FieldInValid2() {
    return this.form.get('importe').touched && this.form.get('importe').invalid;
  }

  FieldValid3() {
    return this.form.get('codigo').touched && this.form.get('codigo').valid;
  }

  FieldInValid3() {
    return this.form.get('codigo').touched && this.form.get('codigo').invalid;
  }
}

